import { SendgridSuppressionGroup } from '@west-australian-newspapers/email-queue-message-types'
import React, { useState } from 'react'
import {
    StyledNewsletterSubscriptionOptions,
    StyledOptionsTableHeader,
    StyledOptionsTableItem,
    StyledTableItemDescription,
    StyledTableItemName,
    StyledTableItemToggle,
} from './NewsletterSubscriptionOptions.styled'

export interface NewsletterSubscriptionOptionsItem {
    id: SendgridSuppressionGroup
    name: string
    description?: string
    optOut?: boolean
}

export type NewsletterSubscriptionOptionsValues = Partial<
    Record<SendgridSuppressionGroup, boolean>
>

interface NewsletterSubscriptionOptionsProps {
    options: NewsletterSubscriptionOptionsItem[]
    disabled?: boolean
    onChange: (values: NewsletterSubscriptionOptionsValues) => void
}

const getStateFromOptions = (
    options: NewsletterSubscriptionOptionsItem[],
): NewsletterSubscriptionOptionsValues => {
    return options.reduce<NewsletterSubscriptionOptionsValues>((prev, next) => {
        prev[next.id] = next.optOut || false
        return prev
    }, {})
}

export const NewsletterSubscriptionOptions: React.FC<NewsletterSubscriptionOptionsProps> =
    ({ options, disabled, onChange }) => {
        const [state, setState] = useState(getStateFromOptions(options))

        const onToggle = (option: NewsletterSubscriptionOptionsItem) => {
            if (disabled) {
                return
            }
            const newState = {
                ...state,
                [option.id]: !state[option.id],
            }
            setState(newState)
            onChange(newState)
        }

        return (
            <StyledNewsletterSubscriptionOptions>
                <StyledOptionsTableHeader>
                    <span>Email</span>
                    <span>Subscribe</span>
                </StyledOptionsTableHeader>
                {options.map((option, index) => (
                    <StyledOptionsTableItem key={index}>
                        <StyledTableItemDescription>
                            <StyledTableItemName>
                                {option.name}
                            </StyledTableItemName>
                            {option.description}
                        </StyledTableItemDescription>
                        <StyledTableItemToggle
                            checked={!state[option.id]}
                            onToggle={() => onToggle(option)}
                            on="Yes"
                            off="No"
                        ></StyledTableItemToggle>
                    </StyledOptionsTableItem>
                ))}
            </StyledNewsletterSubscriptionOptions>
        )
    }
